"use client";

import { Fieldset as FieldsetPrimitive } from "@base-ui/react/fieldset";
import type React from "react";
import { cn } from "../../lib/utils";

/**
 * A group of controls under one caption: radios, or checkboxes that each
 * answer for themselves. Use it, not a `Field`, when the group holds more
 * than one control. A `Field` lends its label to every control inside it,
 * so each checkbox would be announced by the group's caption, not its own.
 */
export function Fieldset({
  className,
  ...props
}: FieldsetPrimitive.Root.Props): React.ReactElement {
  return (
    <FieldsetPrimitive.Root
      className={cn("flex flex-col items-start gap-2", className)}
      data-slot="fieldset"
      {...props}
    />
  );
}

/** The group's caption, on the same rung as a `FieldLabel`. */
export function FieldsetLegend({
  className,
  ...props
}: FieldsetPrimitive.Legend.Props): React.ReactElement {
  return (
    <FieldsetPrimitive.Legend
      className={cn(
        "inline-flex items-center gap-2 font-medium text-xs/4 text-muted-foreground data-disabled:opacity-64",
        className,
      )}
      data-slot="fieldset-legend"
      {...props}
    />
  );
}
